import React from 'react';
import PropTypes from 'prop-types';
import OtpInput from 'react-otp-input';
import styles from '../../../assets/css/login/login.module.css';

const LoginForm = ({
    children,
    required,
    view,
    otp,
    email,
    onChangeOtp,
    onChangeEmail,
    text1,
    mailNotFound,
    handleSubmit,
    handleSendEmail
}) => {
    console.log('mi emaillllll', email);
    return (
        <>
            {view === 3 ? (
                <form
                    className={`${styles.form_login} ${styles.login_create_vendor}`}
                    onSubmit={handleSubmit}>
                    <label className={styles.labelLeft} htmlFor="email">
                        {text1}
                        {required && <span>*</span>}
                    </label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={onChangeEmail}
                        className={mailNotFound ? styles.form_login_error : ''}
                    />
                    {mailNotFound && (
                        <div className={styles.email_not_found_content}>
                            <span>Email not found. Try again.</span>
                        </div>
                    )}

                    {children}
                </form>
            ) : view === 2 ? (
                <>
                    <form onSubmit={handleSubmit}>
                        <label htmlFor="email">
                            {text1}
                            {required && <span>*</span>}
                        </label>
                        <OtpInput
                            onChange={onChangeOtp}
                            numInputs={6}
                            separator={<span>&nbsp;&nbsp;</span>}
                            value={otp}
                            inputStyle={styles.otp_code_input}
                            placeholder="000000"
                            shouldAutoFocus={true}
                            hasErrored={mailNotFound}
                            errorStyle={styles.otp_code__input__error}
                        />
                        {mailNotFound && (
                            <div className={styles.email_not_found_content}>
                                <span>Invalid passcode. Try again.</span>
                            </div>
                        )}

                        {children}
                    </form>
                    <button
                        className={styles.resend__passcode}
                        onClick={handleSendEmail}>
                        Resend Passcode
                    </button>
                </>
            ) : (
                <form className={styles.form_login} onSubmit={handleSubmit}>
                    <label htmlFor="email">
                        {text1}
                        {required && <span>*</span>}
                    </label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={email}
                        onChange={onChangeEmail}
                        className={mailNotFound ? styles.form_login_error : ''}
                    />
                    {mailNotFound && (
                        <div className={styles.email_not_found_content}>
                            <span>Email not found. Try again.</span>
                        </div>
                    )}

                    {children}
                </form>
            )}
        </>
    );
};
LoginForm.propTypes = {
    children: PropTypes.node.isRequired,
    required: PropTypes.bool,
    mailNotFound: PropTypes.bool,
    view: PropTypes.number.isRequired,
    otp: PropTypes.string,
    email: PropTypes.string,
    onChangeOtp: PropTypes.func,
    onChangeEmail: PropTypes.func,
    handleSubmit: PropTypes.func,
    handleSendEmail: PropTypes.func,
    text1: PropTypes.string
};

export default LoginForm;
